import React, { useContext, useEffect } from "react";
import { Layout } from "antd";
import { useMediaQuery } from "react-responsive";

import { OtherUserHeaderProfile } from "../../../../components/otherUser/OtherUserHeaderProfile";
import { UiTextsContext } from "../../../../contexts/Contexts";
import NewSideBarHousing from "../../../../components/layout/newSideBar/NewSideBar";
import NewNavBar from "../../../newHome/NewNavBar/NewNavBar";
import "../../OhterUser/otherUser.css";

const DesktopSideBar = ({ routes, userInfo, relation }) => {
  const { texts } = useContext(UiTextsContext);
  const { Header, Content, Sider } = Layout;
  const isMobile = useMediaQuery({ maxWidth: 1200 });

  useEffect(() => {
    document.body.classList.add("vn-home-route");
    return () => document.body.classList.remove("vn-home-route");
  }, []);

  return (
    <Layout className="other-user-shell">
      <Header className="main-header">
        <NewNavBar />
      </Header>

      {!isMobile ? (
        <Sider className="navigation-menu">
          <NewSideBarHousing uiTexts={texts} />
        </Sider>
      ) : (
        <NewSideBarHousing uiTexts={texts} />
      )}

      <Content className="other-user-shell__content">
        <div className="other-user-page">
          <div className="other-user-content">
            <OtherUserHeaderProfile user={userInfo} relation={relation} />
            {routes}
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default DesktopSideBar;
